import {
  BankOutlined, BarChartOutlined, CarOutlined, FileTextOutlined, InboxOutlined, ShopOutlined,
} from '@ant-design/icons';
import { Col, Row } from 'antd';
import CardLink from 'components/CardLink';
import { PERMISSIONS } from 'constants/permissions';
import { useHasAnyOfPermissions } from 'hooks/useHasPermission';
import React from 'react';

function ReportTypesContainer() {
  const isAdmin = useHasAnyOfPermissions([PERMISSIONS.ADMIN_ACCESS]);
  const actions = [
    isAdmin && {
      key: 'general_report',
      title: 'General Report',
      icon: <BarChartOutlined />,
      description: 'A comprehensive summary of your business which includes information such as your total sales, total number of orders, etc.',
      link: '/console/reports/general',
    },
    {
      key: 'merchants_report',
      title: 'Restaurants Report',
      icon: <ShopOutlined />,
      description: 'This report includes general information about your restaurants separated by restaurant’s name.',
      link: '/console/reports/merchants',
    },
    isAdmin && {
      key: 'orders_report',
      title: 'Orders Report',
      icon: <InboxOutlined />,
      description: 'This report includes a log of all completed and cancelled orders as well as details such as restaurant net, RDS net, etc.',
      link: '/console/reports/orders',
    },
    {
      key: 'expedite_deliveries_report',
      title: 'Expedite Deliveries',
      icon: <CarOutlined />,
      description:
        'Orders where delivery was charged or fulfilled via Expedite, with delivery fee and tip for auditing and billing reconciliation.',
      link: '/console/reports/expedite-deliveries',
    },
    {
      key: 'payouts_report',
      title: 'Payouts Report',
      icon: <BankOutlined />,
      description: 'A summary of your total sales, number of orders, and payout details. Nibble sends daily or weekly payouts based on your organization\'s schedule.',
      link: '/console/reports/payouts',
    },
  ].filter(Boolean);
  return (
    <Row gutter={[16, 16]}>
      {actions.map(({
        key, title, icon, description, link,
      }) => (
        <Col xs={24} sm={12} lg={8} key={key}>
          <CardLink
            title={title}
            icon={icon}
            description={description}
            link={link}
          />
        </Col>
      ))}
    </Row>
  );
}

export default ReportTypesContainer;
